import { render } from "./ManageView.vue?vue&type=template&id=ea63a440"
import script from "./ManageView.vue?vue&type=script&lang=js"
export * from "./ManageView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__